export default {
  'pt-BR': 'Português (BR)',
  'pt-PT': 'Português (PT)',
  'en-US': 'English (US)',
  'es-ES': 'Español (ES)',
  'ja-JP': '日本語 (JP)',
  options: [
    { value: 'pt-BR', text: 'Português (BR)' },
    { value: 'pt-PT', text: 'Português (PT)' },
    { value: 'en-US', text: 'English (US)' },
    { value: 'es-ES', text: 'Español (ES)' },
    { value: 'ja-JP', text: '日本語 (JP)' },
  ],
}
